import type { ReactNode } from "react";
import { useOrgRole } from "@/hooks/useOrgRole";
import type { Permission } from "@/lib/rbac";

interface RoleGateProps {
  permission: Permission;
  children: ReactNode;
  fallback?: ReactNode;
  /** If true, renders children but disabled (via wrapper) */
  disableOnly?: boolean;
}

export function RoleGate({ permission, children, fallback = null, disableOnly = false }: RoleGateProps) {
  const { can, isLoading } = useOrgRole();

  if (isLoading) return null;

  if (!can(permission)) {
    if (disableOnly) {
      return <div className="opacity-50 pointer-events-none select-none">{children}</div>;
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
